<template>
  <a-modal
          title="受检单位信息"
          okText="确认"
          cancelText="取消"
          width="1000px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="受检单位名称" prop="name">
            <a-input v-model="formState.name"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item label="受检单位代码" prop="code">
            <a-input v-model="formState.code"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="法人或负责人姓名" prop="bossName">
            <a-input v-model="formState.bossName"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item label="邮编" prop="mailCode">
            <a-input v-model="formState.mailCode"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="联系人" prop="connectName">
            <a-input v-model="formState.connectName"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item label="联系电话" prop="tel">
            <a-input v-model="formState.tel"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="传真" prop="fax">
            <a-input v-model="formState.fax"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item label="主管单位" prop="leaderOrg">
            <a-input v-model="formState.leaderOrg"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="所属区域" prop="district">
            <a-ext-dist-picker-qu v-model="formState.district"></a-ext-dist-picker-qu>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item label="所属乡镇/街道" prop="town">
            <a-input v-model="formState.town"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="监测环节" prop="checkType">
            <a-ext-local-dic-select dic-key="MonitLink" v-model="formState.checkType"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item label="受检单位性质" prop="orgType">
            <a-ext-local-dic-select dic-key="DanWeiXingZhi" v-model="formState.orgType"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="规模类型" prop="lotType">
            <a-ext-local-dic-select dic-key="GuiMoLeiXing" v-model="formState.lotType"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item label="规模单位" prop="lotUnit">
            <a-ext-local-dic-select dic-key="Unit" v-model="formState.lotUnit"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="企业规模" prop="orgLot">
            <a-input v-model="formState.orgLot"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item label="经度" prop="lng">
            <a-input v-model="formState.lng"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="纬度" prop="lat">
            <a-input v-model="formState.lat"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="详细地址" prop="address">
            <a-input v-model="formState.address"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>



    </a-form-model>

  </a-modal>
</template>

<script>

import AExtDistPickerQu from '../../../components/AntDesignExt/All/AExtDistPickerQu'
import AExtLocalDicSelect from '../../../components/AntDesignExt/All/AExtLocalDicSelect'
import {addorUpdateONeedChecker as saveApi, getONeedCheckerById as initApi} from '../../../api/api'
import {FormRules} from 'antd-form-rules';

export default {
    name: "FormModel",
    components: {
        AExtDistPickerQu, AExtLocalDicSelect,
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        param: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            confirmLoading: false,
            formState: {
                name: '',
                code: '',
                boss_name: '',
                mail_code: '',
                connect_name: '',
                tel: '',
                fax: '',
                leader_org: '',
                city: '',
                town: '',
                check_type: '',
                org_type: '',
                lot_type: '',
                lot_unit: '',
                org_lot: '',
                lng: '',
                lat: '',
                address: '',
            },
            rules: {
                name: FormRules.withName('受检单位名称').string(1, 200).isRequired().create(),
                code: FormRules.withName('受检单位代码').string(1, 50).isRequired().create(),
                bossName: FormRules.withName('法人或负责人姓名').string(1, 50).isRequired().create(),
                mailCode: FormRules.withName('邮编').string(1, 50).isRequired().create(),
                connectName: FormRules.withName('联系人').string(1, 50).isRequired().create(),
                district: FormRules.withName('联系人').string(1, 50,'必须选择行政区划').isRequired().create(),
                tel: FormRules.withName('联系电话').phone().isRequired().create(),
                city: FormRules.withName('所属区域').isRequired().create(),
                checkType: FormRules.withName('监测环节').isRequired().create(),
                lng: FormRules.withName('经度').number(0,180).isRequired().create(),
                lat: FormRules.withName('维度').number(0,90).isRequired().create(),
                orgLot: FormRules.withName('企业规模').number(0,).isRequired().create(),
                address: FormRules.withName('详细地址').string(1, 200).isRequired().create(),
            },

        };
    },
    created() {
        this.initForm();
    },
    methods: {
        initForm() {
            if (this.param.id) {
                this.confirmLoading = true;
                initApi(this.param).then((result => {
                    if(result.data&&result.data.data) {
                        this.formState = result.data.data;
                    }
                    this.confirmLoading = false;
                })).catch(() => {
                    this.confirmLoading = false;
                });
            }
        },
        handleOk(e) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    saveApi(this.formState).then((result => {
                        this.confirmLoading = false;
                        this.$emit("addNeedCheckerModalClose", true)
                        this.$emit("update:visible", false)
                    })).catch(() => {
                        this.confirmLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.$emit("update:visible", false)
        },

    },
}
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body {
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>